/*
 * Module for the Insurance deduction detail tab
*/
rs.module("content/participant/benefit/insurance/edit/insurancedetailtab",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, insuranceDeductionKey, insuranceType, isAdd, isUsedInPayrollRecords, backendUrls) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var updateToken = form.js(jsSelectors.updateToken);
            var insuranceTypeSelect = form.js(jsSelectors.insuranceTypeSelect, { required: false });
            var insuranceCarrierSelect = form.js(jsSelectors.insuranceCarrierSelect, { required: false });
            var insuranceCoverageSelect = form.js(jsSelectors.insuranceCoverageSelect, { required: false });
            var deductionEffectiveDateInput = form.js(jsSelectors.deductionEffectiveDateInput);
            var deductionTerminationDateInput = form.js(jsSelectors.deductionTerminationDateInput);
            var coverageEffectiveDateInput = form.js(jsSelectors.coverageEffectiveDateInput);
            var coverageTerminationDateInput = form.js(jsSelectors.coverageTerminationDateInput);
            var terminationReasonSelect = form.js(jsSelectors.terminationReasonSelect);
            var cancelButton = form.js(jsSelectors.cancelButton, { required:false });

            if (!isUsedInPayrollRecords) {

                // Get select helper(s)
                var insuranceCarrierSelectHelper = selectHelper.getHelper(insuranceCarrierSelect);
                var insuranceCoverageSelectHelper = selectHelper.getHelper(insuranceCoverageSelect);

                insuranceTypeSelect.change(function () {

                    if (insuranceTypeSelect.val() == '') {

                        insuranceCarrierSelectHelper.clearOptions();
                        insuranceCarrierSelectHelper.setDisabled(true);
                    }
                    else {

                        insuranceCarrierSelectHelper.loadOptionsFrom(
                            backendUrls.LoadInsuranceCarrierOptions,
                            { insuranceType: insuranceTypeSelect.val() },
                            { withBlank: true }
                        );
                        insuranceCarrierSelectHelper.setDisabled(false);
                    }

                    insuranceCoverageSelectHelper.clearOptions();
                    insuranceCoverageSelectHelper.setDisabled(true);

                    // Clear errors
                    [
                        insuranceTypeSelect,
                        insuranceCarrierSelect,
                        insuranceCoverageSelect
                    ].forEach((input) => input.clearErrors());
                });

                insuranceCarrierSelect.change(function () {

                    if (insuranceCarrierSelect.val() == '') {

                        insuranceCoverageSelectHelper.clearOptions();
                        insuranceCoverageSelectHelper.setDisabled(true);
                    }
                    else {

                        insuranceCoverageSelectHelper.loadOptionsFrom(
                            backendUrls.LoadInsuranceCoverageOptions,
                            { insuranceType: insuranceTypeSelect.val(), insuranceCarrierKey: insuranceCarrierSelect.val() },
                            { withBlank: true }
                        );

                        insuranceCoverageSelectHelper.setDisabled(false);
                    }

                    // Clear errors
                    [
                        insuranceCarrierSelect,
                        insuranceCoverageSelect
                    ].forEach((input) => input.clearErrors());
                });

                insuranceCoverageSelect.change(function () {
                    insuranceCoverageSelect.clearErrors();
                });
            }

            // Only link Cancel button listeners up if editing
            if (!isAdd) {

                // Get select helper(s)
                var terminationReasonSelectHelper = selectHelper.getHelper(terminationReasonSelect);
                var insuranceTypeSelectHelper = selectHelper.getHelper(insuranceTypeSelect);
                var insuranceCarrierSelectHelper = selectHelper.getHelper(insuranceCarrierSelect);
                var insuranceCoverageSelectHelper = selectHelper.getHelper(insuranceCoverageSelect);

                // On cancel, clear changes to form
                cancelButton.click(function () {

                    $.getJSON(backendUrls.LoadInsuranceDeductionDetail, { insuranceDeductionKey: insuranceDeductionKey }).done(function (data) {

                        updateToken.val(data.updateToken);
                        deductionEffectiveDateInput.val(data.deductionEffectiveDate);
                        deductionTerminationDateInput.val(data.deductionTerminationDate);
                        coverageEffectiveDateInput.val(data.coverageEffectiveDate);
                        coverageTerminationDateInput.val(data.coverageTerminationDate);
                        terminationReasonSelectHelper.setValue(data.terminationReason);

                        if (!isUsedInPayrollRecords) {
                            insuranceTypeSelectHelper.setValue(insuranceType);

                            insuranceCarrierSelectHelper.setDisabled(false);
                            insuranceCarrierSelectHelper.loadOptionsFrom(
                                backendUrls.LoadInsuranceCarrierOptions,
                                { insuranceType: insuranceType },
                                { withBlank: true },
                                function () {
                                    insuranceCarrierSelectHelper.setValue(data.insuranceCarrierKey);
                                }
                            );

                            insuranceCoverageSelectHelper.setDisabled(false);
                            insuranceCoverageSelectHelper.loadOptionsFrom(
                                backendUrls.LoadInsuranceCoverageOptions,
                                { insuranceType: insuranceType, insuranceCarrierKey: data.insuranceCarrierKey },
                                { withBlank: true },
                                function () {
                                    insuranceCoverageSelectHelper.setValue(data.insuranceCoverageKey);
                                }
                            );
                        }

                        // Clear errors
                        [
                            insuranceTypeSelect,
                            insuranceCarrierSelect,
                            insuranceCoverageSelect,
                            deductionEffectiveDateInput
                        ].forEach((input) => input.clearErrors());

                        eventBanner.removeAllMessages();
                    });
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);